export default "__VITE_ASSET__BPrrhHOq__"